import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AngularMaterialModule } from '../angular-material/angular-material.module';

import { EduNotificationComponent } from './edu-notification/edu-notification.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AngularMaterialModule
    ],
    declarations: [EduNotificationComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [EduNotificationComponent]
})
export class NotificationsModule { }
